import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../../services/api";
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()


export default {
    data() {
        return {
            locale: LocService,
            model: {
                date: '',
                maxTrainings: 0,
                startAt: '',
                trainingType: "",
                notifyUsers: false,
                trainerOnSlot: null
            },
            partners: [],
            trainingNumbers: LocService.t('label_max_people_on_training'),
            chooseUser: false,
            selectedUsers: [],
            isVisibleAddUserToTerm: false,
            showAddTrainerToSlot: false,
            types: [],
        }
    },
    methods: {
        addTraining: addTraining,
        showChoseUser: showChoseUser,
        loadPartners: loadPartners,
        extendPayment: extendPayment,
        reserveTrainingForUser: reserveTrainingForUser,
        removeSelectedUser: removeSelectedUser,
        getTrainingTypes: getTrainingTypes
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.showAddTrainerToSlot = CONFIG_COMPANY.SHOW_ADD_TRAINER_ON_SLOT;
        this.isVisibleAddUserToTerm = session.getConfig().canAddUserWithTerm;
        this.model.date = this.$route.query.date
        this.getTrainingTypes()
        if(this.showAddTrainerToSlot){
            this.loadPartners();
        }
    },
    created() {
        let _self = this;
        this.$topnavbar.$on('closeChooseUser', () => {
            _self.chooseUser = false;
        });

        this.$topnavbar.$on('onUserSelected', (data) => {
            // _self.chooseUser = false;
            if(!_self.selectedUsers.map(u => u.id).includes(data.id)){
                _self.selectedUsers.push(data)
            }
        });
    }
}

function removeSelectedUser(sUser){
    this.selectedUsers = this.selectedUsers.filter(u => sUser.id !== u.id)
    // this.selectedUsers = [];
    // this.selectedUsers = null;
}
function showChoseUser(){
    this.chooseUser = true;
}

function loadPartners() {
    let _self = this;
    AdminApiService.getCompanyPayments()
        .then((response) => {
            _self.partners = response.data
        })
        .catch(error => {
            swal( LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}


function addTraining() {
    if(this.selectedUsers.length > this.model.maxTrainings){
        swal('Greška', 'Stavili ste više ljudi nego sto termin prima.', 'error')
        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte...</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {});

    let _self = this;
    if(this.selectedUsers.length > 0){
        this.model.userIds = this.selectedUsers.map(e => e.id);
    }else{
        this.model.userIds = null
    }

    AdminApiService.addSlot(this.model)
        .then((response) => {
            if(response.data.shouldExtendPayment === true){
                swal(LocService.t("label_error"), LocService.t("label_some_user_expire_payment"), 'error')
                // _self.extendPayment(response.data.slotId);
            }else{
                swal(LocService.t("label_success"), LocService.t("label_term_success_saved"), 'success')
                this.$router.push('/trainings?date='+_self.model.date)
            }
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

//todo za sad ne korisimo
function extendPayment(slotId){
    let _self = this;
    swal({
        title: 'Clanarina istekla!',
        text: "Da li zelite korisniku da produzite clanarinu i zakazete trening?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Ne',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Da',
        customClass: 'swal2-warning'
    }).then(function () {
        //ovde nije vise selektovan jedan user vec vise
        // AdminApiService.extendPaymentFromAdmin(_self.selectedUser.id)
        //     .then((response) => {
        //         _self.reserveTrainingForUser(slotId)
        //     })
        //     .catch((error) => {
        //         swal('Greška', error.data.localized_error_message, 'error')
        //     })
    });
}

function reserveTrainingForUser(slotId){
    let _self = this;
    let model = {
        slotId: slotId
    }
    AdminApiService.addTrainingFromAdmin(model, this.selectedUser.id)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t("label_term_success_saved"), 'success')
            this.$router.push('/trainings?date='+_self.model.date)
        })
        .catch((error) => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function getTrainingTypes() {
    let _self = this;
    AdminApiService.getTrainingTypes()
        .then((response) => {
            _self.types = response.data
            for(var temp in response.data) {
                _self.model.trainingType = temp
                return
            }
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Trainings/Add/AddTraining.js